import $ from '@nuskin/nuskinjquery';
import {ConfigService} from '@nuskin/ns-util';

const ScanCardService = function() {
    "use strict";

    let validateScanCard = function(cardNumber, callbackFn) {
        validateScanNumber(cardNumber, successCallBackFn(callbackFn), failedCallbackFn(callbackFn));
    };

    function validateScanNumber(cardNumber, callbackFn, failedCallbackFn) {
        // eslint-disable-next-line
        let url = `${ConfigService.getMarketConfig().siteUrl}${ConfigService.getMarketConfig().nsurl_scanCertCheckService.replace('{certNum}', cardNumber)}`;

        $.ajax({
            type: "GET",
            url: url,
            success: callbackFn,
            error: failedCallbackFn
        });

    }

    function successCallBackFn(_callbackFn) {
        let callbackFn = _callbackFn;
        return function(response) {
            let retVal = {
                valid: response === "true"
            };

            callbackFn(retVal);
        }
    }

    function failedCallbackFn(_callbackFn) {
        let callbackFn = _callbackFn;
        return function() {
            let retVal = {
                valid: false,
                message: "Failed to call scan card validation service"
            };

            callbackFn(retVal);
        }
    }

    return {
        validateScanCard: validateScanCard
    };
}();

export default ScanCardService;
